import { Table, Tbody, Th, Tr } from '@chakra-ui/react';
import React from 'react';

import type { AddressTokenBalance } from 'types/api/address';

import { type Ticker } from 'lib/hooks/usePrice';
import { default as Thead } from 'ui/shared/TheadSticky';

import ERC20TokensTableItem from './ERC20TokensTableItem';

interface Props {
  data: Array<AddressTokenBalance>;
  top: number;
  isLoading: boolean;
  getPriceToken?: (address: string) => Ticker | undefined;
}

const ERC20TokensTable = ({ data, top, isLoading, getPriceToken }: Props) => {
  return (
    <Table variant="simple" size="sm">
      <Thead top={ top }>
        <Tr>
          <Th width="30%" bg="green.400" color="gray.600">Asset</Th>
          <Th width="30%" bg="green.400" color="gray.600">Contract address</Th>
          <Th width="10%" isNumeric bg="green.400" color="gray.600">Price</Th>
          <Th width="15%" isNumeric bg="green.400" color="gray.600">Quantity</Th>
          <Th width="15%" isNumeric bg="green.400" color="gray.600">Value</Th>
        </Tr>
      </Thead>
      <Tbody>
        { data.map((item, index) => (
          <ERC20TokensTableItem key={ item.token.address + (isLoading ? index : '') } { ...item } isLoading={ isLoading } getPriceToken={ getPriceToken }/>
        )) }
      </Tbody>
    </Table>
  );
};

export default ERC20TokensTable;
